import { createContext } from 'react';

import { HoneycombToolbarConfig } from '../types/toolbar.js';
export const HoneycombToolbarConfigContext = createContext<
  HoneycombToolbarConfig | undefined
>(undefined);
